import { render } from "./AddReviewModal.vue?vue&type=template&id=0aaae5be&scoped=true"
import script from "./AddReviewModal.vue?vue&type=script&lang=js"
export * from "./AddReviewModal.vue?vue&type=script&lang=js"

import "./AddReviewModal.vue?vue&type=style&index=0&id=0aaae5be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaae5be"]])

export default __exports__